/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'
import React from 'react'
import Icon from 'src/components/Icon'
import { paragraphMedium } from 'src/components/css'

interface GameRosterErrorProps {
  message: string
}

/** Shown in place of the tables when the roster request fails. */
const GameRosterError: React.FC<GameRosterErrorProps> = ({ message }) => (
  <div css={wrapStyle}>
    <Icon
      name='exclamation-circle'
      css={iconStyle}
      color={colors.FIERY_RED}
      fontSize={32}
    />
    <p css={messageStyle}>{message}</p>
  </div>
)

export default GameRosterError

// ---- styled ----
const wrapStyle = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 16px;
`
const iconStyle = css`
  height: 40px;
  width: 40px;
`
const messageStyle = css`
  ${paragraphMedium}
  color: ${colors.WHITE};
  margin-top: 8px;
  text-align: center;
  text-decoration: underline;
`
